import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAngleDown = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 11,
	height: 6,
	viewBox: "0 0 11 6",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.84375 1.71094C10.1172 1.46484 10.1172 1.05469 9.87109 0.78125C9.625 0.507812 9.21484 0.507812 8.94141 0.753906L5.22266 4.25391L1.53125 0.753906C1.25781 0.507812 0.847656 0.507812 0.601562 0.78125C0.355469 1.05469 0.355469 1.46484 0.628906 1.71094L4.78516 5.64844C4.92188 5.75781 5.08594 5.8125 5.22266 5.8125C5.38672 5.8125 5.55078 5.75781 5.6875 5.64844L9.84375 1.71094Z",
		fill: "#607D8B"
	})]
});
const ForwardRef = forwardRef(SvgAngleDown);
export { ForwardRef as ReactComponent };
